// Configuration variables
const API_IP = process.env.REACT_APP_API_IP;

// In development, use direct backend calls. In production, use nginx proxy
const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? `${API_IP}:3005/api`
    : '/api';

// Exporting the variables
module.exports = {
    API_IP,
    API_BASE_URL
};
